import { createFileRoute } from '@tanstack/react-router'
import PlanoFaturasPage from '@/pages/dashboard/plano-faturas-page'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/plano-faturas'
)({
  component: function PlanoFaturasRoute() {
    return (
      <ProtectedRoute capability={CAPABILITIES.MANAGE_DASHBOARD_CONFIG}>
        <PlanoFaturasPage />
      </ProtectedRoute>
    )
  },
})
